export const DEFAULT_SHP_LOAD_TYPE = 'wms' as const;
export const DEFAULT_VECTOR_LOAD_TYPE = 'wfs' as const;
